<template>
<!--  <Breadcrumb/>-->
  <h3>讲师大全</h3>
  <nav class="fix-nav">
    <ul class="indexNav">
      <!--        <li @click="onNav_fn(-1)" :class="speaker_o.active === -1?'active':''">全部</li>-->
      <li @click="onNav_fn(index)" :class="speaker_o.active === index?'active':''" v-for="(item,index) in speaker_o.speker" :key="index">{{item.initial}}</li>
    </ul>
  </nav>
  <div id="Specialist" :style="{height: mainHeight}">
    <ul class="indexList" v-if="speaker_o.speker.length">
      <li v-for="(item,index) in speaker_o.speker" :key="index">
        <!--索引标识-->
        <h5>{{item.initial}}</h5>
        <dl>
          <dd v-for="(child,cindex) in item.dataInfo" :key="cindex"
              @mousemove="getFamousSpeakerCourses_fn(index,cindex,child.id)"
              @click="toPersonal(child)"
          >
            <img :src="child.avatar" alt="">
            <div class="info">
              <span>
                {{child.name}}
                <!--                <i>1个课程</i>-->
              </span>
              <p>{{child.unit}}</p>
            </div>
            <!-- 课程 -->
            <ul v-if="child.videoList" :class="`${child.videoList.length>1?'len3':''} ${child.videoList.length>6?'len10':''} course`">
              <template v-if="child.videoList.length">
                <li v-for="(v,index) in child.videoList" :key="index" @click.stop="toCourse(v.id)">
                  <img :src="v.cover" alt="">
                  <!-- 名师课程 -->
<!--                  <span>{{v.name}}</span>-->
                  <!-- hover -->
                  <div><span>{{v.name}}</span></div>
                </li>
              </template>
            </ul>
            <p v-else class="loading course">请稍后...</p>
          </dd>
        </dl>
      </li>
    </ul>
    <a-spin :spinning="!speaker_o.speker.length" size="large" class="spin"/>
<!--    <Empty v-else :description="empty_null_text"/>-->
  </div>
</template>

<script>
  import Breadcrumb from '@c/Breadcrumb.vue';
  import {
    getFamousSpeakers,
    getFamousSpeakerCourses
  } from "@/api";
  import { Empty, Spin } from "ant-design-vue";
  import { pageview } from "../../utils/AnalysysAgent";
  import { getUserId,isBrainMedPC } from "@/utils/methods.js";
  import Cookie from "js-cookie";
  export default {
    name: "Specialist",
    components: {
      Breadcrumb,
      Empty,
      [Spin.name]: Spin,
    },
    data() {
      return {
        userId:getUserId(),
        empty_null_text:'请稍后',
        // 名师列表
        speaker_o: {
          // speker: [{     // 专家信息
          //   initial:'',  // 索引
          //   dataInfo:[]  // 索引下的内容
          // }],
          speker:[],
          activeSpekerInfo:[], // 当前索引下的内容，因为分全部个其他各项
          active: -1, // 当前选中的nav  -1为全部
          pageNo: 1,
          pageSize: 10000,
          // 当前专家名下的课程
          course: {
            active: false,
            list: [],
            pageNo: 1,
            pageSize: 50, // 因为课程不多
          },
        },
        oldSpeakerId: 0,  // 保存当前id
        originalMainHeight: 0, // main页面本来高度
        mainHeight: 'auto', // main页面高度
      }
    },
    methods:{
      // 个人中心
      toPersonal(item){
        if(item.systemUserId){
          let href = '/user-center?profileUserId=' + item.systemUserId
          if(isBrainMedPC()){
            href += '&token=' + Cookie.get('wtoken')
          }
          window.open(href, '_blank');
        }
      },
      toCourse(id){
        const routeLink = this.$router.resolve({
          path:  '/pages/coursePlay/coursePlay',
          query: {
            courseId: id
          }
        })
        window.open(routeLink.href, '_blank');
        // this.$router.push('/pages/coursePlay/coursePlay?courseId=' + id);
      },
      // 切换分类
      onNav_fn(index){
        this.speaker_o.active = index;
        var top = document.querySelectorAll('.indexList>li')[index].offsetTop;
        // 设置页面高度
        if(document.querySelectorAll('.indexList>li')[index].offsetHeight < window.innerHeight ){
          this.mainHeight =this.originalMainHeight + window.innerHeight - document.querySelectorAll('.indexList>li')[index].offsetHeight - 350 + 'px';
        }
        // 设置滚动条距离
        this.$nextTick(()=>{
          document.querySelector('html').scrollTop = 0;
          if(isBrainMedPC()){
            document.querySelector('html').scrollTop = document.querySelector('html').scrollTop + top - 20;
          }else{
            document.querySelector('html').scrollTop = document.querySelector('html').scrollTop + top + 40;
          }
        })
      },
      // 名师列表
      getSpeakerList_fn() {
        getFamousSpeakers({
          pageNo: this.speaker_o.pageNo,
          pageSize: this.speaker_o.pageSize,
          display: 'T'
        }).then((res) => {
          console.log("名师列表", res.data);
          if (res.data.code === 1) {
            // 重新组合数据
            let tempArr = [];
            let newArr = [];
            let resData = res.data.list;
            for (let i = 0; i < resData.length; i++) {
              if (tempArr.indexOf(resData[i].initial) === -1) {
                newArr.push({
                  initial: resData[i].initial?resData[i].initial:'#',
                  dataInfo: [resData[i]]
                });
                tempArr.push(resData[i].initial);
              } else {
                for (let j = 0; j < newArr.length; j++) {
                  if (newArr[j].initial == resData[i].initial) {
                    newArr[j].dataInfo.push(resData[i]);
                    break;
                  }
                }
              }
            }
            // A-Z排序
            newArr.sort((a, b) => {
              return (a.initial + '').localeCompare(b.initial + '')
            });
            this.speaker_o.speker = newArr;
            this.speaker_o.activeSpekerInfo = this.speaker_o.speker;
            this.$nextTick(()=>{
              this.originalMainHeight = document.querySelector('#Specialist').offsetHeight;
            })
          }
        });
      },



      // 根据讲师获取课程 fatherIndex：属于什么索引，childIndex：哪个专家 speakerId专家id
      getFamousSpeakerCourses_fn(fatherIndex,childIndex,speakerId) {
        // 防止多次触发
        if(this.oldSpeakerId === speakerId){
          return;
        }
        this.oldSpeakerId = speakerId;
        // 之前请求到数据就不重复请求了
        if (this.speaker_o.speker[fatherIndex].dataInfo[childIndex].videoList) {
          return;
        }
        // 请求接口
        getFamousSpeakerCourses({
          pageNo: this.speaker_o.pageNo,
          pageSize: this.speaker_o.pageSize,
          speakerId: speakerId,
          display: 'T'
        }).then((res) => {
          if (res.data.code === 1) {
            console.log("名师下的课程", res.data.list);
            // nav全部
            this.speaker_o.speker[fatherIndex].dataInfo[childIndex].videoList = res.data.list;
            this.speaker_o.activeSpekerInfo[fatherIndex].dataInfo[childIndex].videoList = res.data.list;
          }
        });
      },
    },
    mounted() {
      pageview(String(this.userId),'',"云课堂-讲师大全",this.$route.fullPath)
      this.getSpeakerList_fn();
    },
  }
</script>

<style scoped lang="scss">
  nav {
    font-size: 18px;
    display: flex;
    justify-content: center;
    width: 100%;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 999;
    margin: 0;

    .indexNav {
      display: flex;
      flex: 1;
      justify-content: flex-start;
      border-bottom: 2px solid #F1F1F1;
      padding: 15px 0;
      max-width: 1150px;

      li {
        border-radius: 6px;
        flex: 0 0 auto;
        /*line-height: 36px;*/
        text-align: center;
        margin-right: 10px;
        padding:0 10px;
        cursor: pointer;

        &.active {
          background: $theme_blue;
          color: #fff;
        }
      }
    }
  }

  #Specialist {
    background: #fff;
    border-radius: 6px;
    padding: 6px 30px;
    position: relative;
    @extend %safetyWidth;
  }

  .indexList {
    display: flex;
    flex-direction: column;

    & > li {
      display: flex;
      margin: 6px 0;

      h5 {
        font-size: 22px;
        margin-top: 14px;
        flex: 0 0 auto;
        width: 70px;
        padding-left: 20px;
        margin-right: 20px;
      }

      dl {
        display: flex;
        flex-wrap: wrap;

        dd {
          display: flex;
          align-items: center;
          width: 350px;
          margin: 10px 0;
          position: relative;

          & > img {
            width: 44px;
            height: 44px;
            border-radius: 8px;
            margin-right: 10px;
            overflow: hidden;
            object-fit: cover;
            cursor: pointer;
          }

          .info {
            display: flex;
            flex-direction: column;
            flex: 1;
            width: 0;
            margin-right: 20px;
            cursor: pointer;

            span {
              font-size: 16px;
              display: flex;
              align-items: center;

              i {
                color: $theme_blue;
                line-height: 20px;
                padding: 0 8px;
                background: rgba(5, 129, 206, 0.15);
                border-radius: 4px;
                margin-left: 10px;
                font-size: 10px;
              }
            }

            p {
              font-size: 12px;
              color: #666666;
              margin-top: auto;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          &:hover::after, &:hover .course {
            visibility: visible;
            opacity: 1;
            transition-delay: 0.2s;
          }

          &::after {
            content: '';
            position: absolute;
            top: 46px;
            left: 12px;
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 12px solid rgba(79, 79, 79, 1);
            visibility: hidden;
            opacity: 0;
            transition: all .2s;
            transition-delay: .2s;
            z-index: 10;
          }

          .course {
            top: 56px;
            left: 0;
            background: rgba(49, 49, 49, 0.85);
            padding: 5px;
            border-radius: 6px;
            position: absolute;
            z-index: 10;
            display: flex;
            flex-wrap: wrap;
            visibility: hidden;
            opacity: 0;
            transition: all .2s;
            transition-delay: .2s;
            scrollbar-width: none; /* firefox */
            -ms-overflow-style: none; /* IE 10+ */

            &::-webkit-scrollbar {
              display: none; /* Chrome Safari */
              width: 0;
            }

            /* 设置了盒子的最大宽度 */
            &.len3 {
              width: 310px;
            }

            &.len10 {
              height: 280px;
              overflow: auto;
            }

            &::-webkit-scrollbar {
              display: none;
            }

            li {
              margin: 5px;
              border-radius: 6px;
              overflow: hidden;
              position: relative;
              flex: 0 0 auto;

              img {
                width: 140px;
                height: 75px;
                border-radius: 6px;
              }

              & > span {
                position: absolute;
                padding: 0 10px;
                color: #fff;
                width: 100%;
                left: 0;
                right: 0;
                bottom: 10px;
                margin: auto;
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              }

              div {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background: rgba(0, 0, 0, 0.7);
                color: #fff;
                padding: 0 10px;
                display: flex;
                align-items: center;
                opacity: 0;
                transition: all .3s;

                span {
                  font-size: 16px;
                  word-break: break-all;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                }
              }

              &:hover div {
                opacity: 1;
              }
            }
          }
        }
      }
    }
  }
  .loading {
    color:#fff;
    line-height: 60px;
    width: 100px;
    justify-content: center;
  }
  .spin{
    margin: 100px auto;
    display: block;
  }
  h3{
    font-size: 20px;
    @extend %safetyWidth;
    margin: 20px auto 0;
  }
</style>
